import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthToken } from '../../utils/authUtils';


// Helper function to get API base URL
function getApiBaseUrl() {
  return process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
}

export const createAuditLog = createAsyncThunk(
  'audit/createLog',
  async (logData, { rejectWithValue }) => {
    try {
      const token = await getAuthToken();
      const response = await fetch(
        `${getApiBaseUrl()}/internal/audit/logs`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(logData)
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create audit log');
      }

      const result = await response.json();
      
      // Return serializable data for Redux
      return {
        ...logData,
        id: result.id,
        timestamp: new Date().toISOString()
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAuditLogs = createAsyncThunk(
  'audit/fetchLogs',
  async ({ startDate, endDate, userId }, { rejectWithValue }) => {
    try {
      const token = await getAuthToken();
      const params = new URLSearchParams();

      // Add default constraint to get recent logs if no filters are applied
      if (!startDate && !endDate && !userId) {
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        params.append('startDate', thirtyDaysAgo.toISOString());
      } else {
        if (startDate) {
          params.append('startDate', startDate);
        }
        if (endDate) {
          params.append('endDate', endDate);
        }
        if (userId) {
          params.append('targetUserId', userId);
        }
      }

      // Add pagination
      params.append('page', '1');
      params.append('limit', '100');

      const response = await fetch(
        `${getApiBaseUrl()}/internal/audit/logs?${params}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch audit logs');
      }

      const result = await response.json();
      return result.logs;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
